// Global values for entire application

// Calendar menu items
const CALENDAR_ITEMS = ["today", "next 7 days", "all days"];

// Next7days days
const DAYS = ["0", "1", "2", "3", "4", "5", "6"];

// Default project day use in TodoContext
const DEFAULT_PROJECT_DAY = "today";

// Firebase values configuration
const FIREBASE_API_KEY = "AIzaSyBlIURB2kUPUTw4STE6eqrGMP0MBBYvYHs";
const FIREBASE_AUTH_DOMAIN = "todo-firebase-451eb.firebaseapp.com";
const FIREBASE_PROJECT_ID = "todo-firebase-451eb";
const FIREBASE_STORAGE_BUCKET = "todo-firebase-451eb.appspot.com";
const FIREBASE_MESSAGING_SENDER_ID = "49842254315";
const FIREBASE_APP_ID = "1:49842254315:web:031106b44afa64d44fa9ae";

// Firebase collections
const FIREBASE_TODOS_COLLECTION_NAME = "todos";
const FIREBASE_PROJECTS_COLLECTION_NAME = "projects";

export {
	CALENDAR_ITEMS,
	FIREBASE_API_KEY,
	FIREBASE_AUTH_DOMAIN,
	FIREBASE_PROJECT_ID,
	FIREBASE_STORAGE_BUCKET,
	FIREBASE_MESSAGING_SENDER_ID,
	FIREBASE_APP_ID,
	FIREBASE_TODOS_COLLECTION_NAME,
	FIREBASE_PROJECTS_COLLECTION_NAME,
	DAYS,
	DEFAULT_PROJECT_DAY,
};
